import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { configureHeaders } from "./libs/http-service/interceptors/http.interceptors";
import { configureInterceptors } from "./libs/http-service/interceptors/http.interceptors";
const root = ReactDOM.createRoot(document.getElementById("root"));

configureHeaders();
configureInterceptors();


root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
